import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';

import { ReconcileDataContext } from 'root/apps/InventoryCountReconcile/contexts/ReconcileData';

const IntroView = () => {
  const { isLoading, triggerReconcile } = React.useContext(ReconcileDataContext);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    if (
      // eslint-disable-next-line no-alert
      confirm(
        'Make sure you verified all the information in the table because this action can’t be undone.'
      )
    ) {
      // not awaiting - fire & forget
      triggerReconcile();
    }
  };

  return (
    <Box data-test="intro-view">
      <ul>
        <li>Reconciling will change inventory records to match your count.</li>
        <li>Check Missed items before you reconcile.</li>
        <li>Make sure the numbers in the table are accurate.</li>
        <li>
          <strong>This action can’t be undone.</strong>
        </li>
      </ul>
      <Flex justifyContent="flex-end" alignItems="center" p={2}>
        <Button
          fill
          variant="secondary"
          size="small"
          onClick={handleClick}
          loading={isLoading}
          data-test="trigger-reconcile-button"
        >
          Reconcile inventory
        </Button>
      </Flex>
    </Box>
  );
};

export default IntroView;
